import React from 'react'

import { Header, Footer, HowItWorks, HowToJoin, MainFeatures, OurApps, Download } from './Sections'
import './styles.scss'

function LandingComponent() {
  return (
    <div className='bl_root'>
      <Header />
      <HowItWorks />
      <HowToJoin />
      <MainFeatures />
      <OurApps />
      <Download />
      <Footer />
    </div>
  )
}

export default LandingComponent
